<div class="simple-input-with-icon">
    <mat-form-field appearance="outline" [color]="color">
        <mat-label class="placeholder">{{text}}</mat-label>
        <mat-icon *ngIf="iconPosition === 'left'" matPrefix class="arrow-icon">{{icon}}</mat-icon>
        <input placeholder="{{placeholder}}" matInput>
        <mat-icon *ngIf="iconPosition === 'right'" matSuffix class="arrow-icon">{{icon}}</mat-icon>
    </mat-form-field>
</div>
